// Copyright 2025. WebPros International GmbH. All rights reserved.

import { Translate } from '@plesk/ui-library';
import { Dialog } from 'common/components/Dialog/Dialog';
import ErrorMessage from 'admin/disasterRecovery/components/ErrorMessage/ErrorMessage';

interface IProps {
    isOpen: boolean;
    onClose: () => void;
}

export default function ArchTypesConflictDialog({
    isOpen,
    onClose,
}: IProps) {
    return (
        <Dialog
            heading={<Translate content="disasterRecovery.readinessStatus.destinationComputeResources.table.archType" />}
            closeHandler={onClose}
            isOpen={isOpen}
            size={'sm'}
        >
            <ErrorMessage>
                <Translate
                    content="disasterRecovery.readinessStatus.destinationComputeResources.dialogs.archType"
                />
            </ErrorMessage>
        </Dialog>
    );
}